"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersModal = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var react_use_1 = require("react-use");
var button_chip_1 = require("./button-chip");
var filters_form_1 = require("./filters-form");
var search_params_1 = require("./lib/search-params");
var use_filter_documents_table_1 = require("./lib/use-filter-documents-table");
function formValuesToQuery(formValues) {
    var searchParams = new search_params_1.SearchParams();
    var query = searchParams.toParsed();
    Object.entries(formValues).forEach(function (_a) {
        var formKey = _a[0], formValue = _a[1];
        var queryValue = Array.isArray(formValue) ? formValue.join(',') : formValue;
        if (queryValue) {
            query[formKey] = queryValue;
        }
        else {
            delete query[formKey];
        }
    });
    return query;
}
function FiltersModal(_a) {
    var _this = this;
    var fileStatus = _a.fileStatus, documentTypes = _a.documentTypes;
    var _b = (0, react_use_1.useToggle)(false), isOpen = _b[0], toggleOpen = _b[1];
    var _c = (0, react_1.useState)(0), filterCount = _c[0], setFilterCount = _c[1];
    var _d = (0, use_filter_documents_table_1.useFilterDocumentsTable)(), filterDocumentsTable = _d.filterDocumentsTable, resetFilters = _d.resetFilters;
    var form = (0, formik_1.useFormik)({
        initialValues: {
            fileStatus: fileStatus,
            documentTypes: documentTypes,
        },
        onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                handleSetFilterCount(values);
                filterDocumentsTable(formValuesToQuery(values));
                toggleOpen();
                return [2 /*return*/];
            });
        }); },
    });
    var handleSetFilterCount = (0, react_1.useCallback)(function (formValues) {
        var query = formValuesToQuery(formValues);
        var formValuesKeys = new Set(Object.keys(formValues));
        setFilterCount(Object.keys(query).filter(function (key) { return formValuesKeys.has(key); }).length);
    }, []);
    (0, react_1.useEffect)(function () {
        handleSetFilterCount(form.initialValues);
    }, [form.initialValues, handleSetFilterCount]);
    (0, react_1.useEffect)(function () {
        if (documentTypes) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            form.setFieldValue('documentTypes', documentTypes);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentTypes]);
    var handleResetFilters = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFilterCount(0);
                    form.resetForm();
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    form.setValues({ documentTypes: undefined, fileStatus: undefined });
                    return [4 /*yield*/, resetFilters()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleResetFilters()];
                case 1:
                    _a.sent();
                    toggleOpen();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(core_ui_1.Padding, null,
        react_1.default.createElement(button_chip_1.ButtonChip, { activeText: "".concat(filterCount, " ").concat(filterCount > 1 ? 'filters' : 'filter'), isActive: filterCount > 0, onClick: toggleOpen, onClose: handleResetFilters }),
        react_1.default.createElement(core_ui_1.Modal, { isOpen: isOpen, onToggle: toggleOpen, width: "710px" },
            react_1.default.createElement(core_ui_1.ModalBody, null,
                react_1.default.createElement(core_ui_1.ModalHeader, { onClose: toggleOpen, titleText: "View options" }),
                react_1.default.createElement(core_ui_1.Padding, { size: 32 },
                    react_1.default.createElement(core_ui_1.Stack, { direction: "vertical", gap: 4 },
                        react_1.default.createElement(filters_form_1.FiltersForm, { onChange: function (name) { return function (val) { return form.setFieldValue(name, val); }; }, form: form }))),
                react_1.default.createElement(core_ui_1.ModalFooter, null,
                    react_1.default.createElement(core_ui_1.Stack, { direction: "horizontal", gap: 8, alignItems: "center", justifyContent: "flex-end" },
                        react_1.default.createElement(core_ui_1.Padding, { right: 8 },
                            react_1.default.createElement(core_ui_1.TextLink, { disabled: filterCount === 0, underline: false, onClick: handleResetFilters }, "Reset")),
                        react_1.default.createElement(core_ui_1.Button, { size: "secondary", onClick: handleCancel }, "Cancel"),
                        react_1.default.createElement(core_ui_1.Button, { size: "primary", loading: form.isSubmitting, onClick: form.submitForm }, "Apply")))))));
}
exports.FiltersModal = FiltersModal;
